import dayjs from 'dayjs';

export const formatDateStringForDatePicker = (dateStr: string): string => {
  // Attempt to parse as 'DD/MM/YYYY' format first
  const parsedDate = dayjs.utc(dateStr, 'DD/MM/YYYY', true);

  if (parsedDate.isValid()) {
    return parsedDate.format('YYYY-MM-DD');
  }

  // If the first attempt fails, try to parse as an ISO date or other valid format
  const isoDate = dayjs.utc(dateStr);
  if (isoDate.isValid()) {
    return isoDate.format('YYYY-MM-DD');
  }

  return ''; // Return empty string for invalid dates
};
